/**
 * 图片懒加载指令
 * Image lazy loading directive
 * 
 * 使用方法 Usage:
 * <img v-lazy="imageUrl" alt="description" />
 */

export default {
  mounted(el, binding) {
    // 创建占位符类
    el.classList.add('image-placeholder')
    
    // 使用 Intersection Observer API 实现懒加载
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = entry.target
            const src = binding.value
            
            // 加载图片
            const tempImg = new Image()
            tempImg.src = src
            
            tempImg.onload = () => {
              img.src = src
              img.classList.remove('image-placeholder')
              img.classList.add('animate-optimized')
              
              // 移除观察
              observer.unobserve(img)
            }
            
            tempImg.onerror = () => {
              // 加载失败处理
              img.classList.remove('image-placeholder')
              img.alt = 'Image failed to load'
              observer.unobserve(img)
            }
          }
        })
      },
      {
        // 提前 100px 开始加载
        rootMargin: '100px',
        threshold: 0.01
      }
    )
    
    observer.observe(el)
    
    // 保存 observer 到元素，用于卸载时清理
    el._lazyLoadObserver = observer
  },
  
  unmounted(el) {
    // 清理 observer
    if (el._lazyLoadObserver) {
      el._lazyLoadObserver.disconnect()
      delete el._lazyLoadObserver
    }
  }
}

